import { gql } from 'graphql-request';
import { supabase } from "@/integrations/supabase/client";

console.log('[GraphQL Client] Using Supabase SDK for GraphQL requests');

// Define a function to execute GraphQL queries/mutations using the Supabase SDK
export async function executeGraphQL<T>(
  query: string,
  variables?: Record<string, any>
): Promise<T> {
  try {
    // Use the Supabase SDK's functions.invoke method to call the GraphQL edge function
    const { data, error } = await supabase.functions.invoke('graphql', {
      body: {
        query, // The GraphQL query/mutation string
        variables // The variables to pass to the query/mutation
      }
      // Removed region specification to avoid CORS issues
    });

    if (error) {
      console.error('❌ [GraphQL Client] Error executing GraphQL:', error);
      throw error;
    }

    // GraphQL responses should contain a data property with the results
    if (!data || !data.data) {
      const errorMessage = data?.errors 
        ? `GraphQL errors: ${JSON.stringify(data.errors)}` 
        : 'Invalid GraphQL response format';
      console.error(`❌ [GraphQL Client] ${errorMessage}`);
      throw new Error(errorMessage);
    }

    console.log('✅ [GraphQL Client] Request successful');
    return data.data as T;
  } catch (error) {
    console.error('❌ [GraphQL Client] Error executing GraphQL request:', error);
    throw error;
  }
}

// Simple wrapper to make GraphQL client code compatible with existing code that expects a GraphQLClient
export const graphqlClient = {
  request: async <T>(query: string | { toString(): string }, variables?: Record<string, any>): Promise<T> => {
    const queryString = typeof query === 'string' ? query : query.toString();
    return executeGraphQL<T>(queryString, variables);
  }
};

// Export headers function for compatibility with any code that might use it
export function getGraphQLHeaders() {
  return {}; // No longer needed as auth is handled by the Supabase SDK
}

// Export endpoint function for compatibility with any code that might use it
export function getGraphQLEndpoint() {
  return 'supabase-sdk://graphql'; // Return a placeholder for code that might check this
}

// Original functions were replaced with the implementations above
